import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TagContract } from '@app-types/api/tag';
import { TagComponentComponent } from '@app-components/common/tag-component/tag-component.component';

@Component({
  selector: 'app-email-tags',
  imports: [TranslateModule, TagComponentComponent],
  templateUrl: './email-tags.component.html',
  styleUrls: ['./email-tags.component.scss'],
})
export class EmailTagsComponent {
  @Input() tags?: TagContract[];

  constructor() {}
}
